module.exports = __webpack_public_path__ + "static/media/04bb9594a871a9b6541c319e5907c456.4d38ede7.jpg";